import { Link } from "react-router-dom";
import { ClientRegistration } from "../../../Component/Model/Dto/Advisory/ClientRegistration";
import { ILinkProps, TableColumn } from "../../../Component/Model/Table/Table";
import { Typography } from "@mui/material";

interface ClientRegistrationRows {
    clientRegistrationName: ILinkProps;
}

interface ClientRegistrationTable {
    columns: Array<TableColumn>;
    rows: Array<ClientRegistrationRows>;
}

export function ClientRegistrationsDataTableColumns(dataObject: ClientRegistration[], setClientRegistration: (registration: ClientRegistration) => void): ClientRegistrationTable {
    const columns = [
        {
            Header: 'Name', accessor: 'clientRegistrationName', id: 'clientRegistrationName',
            Cell: ({ value }: any) => (
                <Typography variant="caption" fontWeight="regular" color="#007bff" component={Link} to={value.linkTo}
                    onClick={() => setClientRegistration({
                        clientRegistrationId: value.clientRegistrationId,
                        clientRegistrationName: value.itemName,
                        optedInRoles: value.optedInRoles
                    })}>
                    {value.itemName}
                </Typography>
            )
        }
    ];

    if (dataObject != undefined && dataObject.length > 0) {
        const rows = dataObject.map((item: ClientRegistration) => ({
            clientRegistrationId: item.clientRegistrationId,
            clientRegistrationName: {
                linkTo: `/advisory/bee/clientScorecards/${item.clientRegistrationId}/${item.clientRegistrationName}`,
                itemName: item.clientRegistrationName,
                clientRegistrationId: item.clientRegistrationId,
                optedInRoles: item.optedInRoles ?? []
            },
        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}

